<template>
  <div class="tw-pt-4 tw-overflow-auto tw-border-b tw-rounded-b-lg">
    <slot />
  </div>
</template>
